import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Badge from '@mui/material/Badge'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'

import type { MenuItem as StaffMenuItem } from '../../../../types/menuItem.types'

interface DrawerMenuItemsProps {
  menuItems: StaffMenuItem[]
  open: boolean
}

const DrawerMenuItems: React.FC<DrawerMenuItemsProps> = ({ menuItems, open }) => {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <List sx={{ flex: 1 }}>
      {menuItems.map((menuItem) => {
        const isSelected = location.pathname === menuItem.url

        return (
          <ListItem key={menuItem.url} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => navigate(menuItem.url)}
              sx={{
                justifyContent: open ? 'initial' : 'center',
                color: isSelected ? theme.palette.secondary.main : 'inherit',
              }}
            >
              <ListItemIcon
                sx={{
                  justifyContent: 'center',
                  mr: open ? 3 : 'auto',
                  '& .menu-item-icon svg': {
                    fill: isSelected ? theme.palette.secondary.main : 'inherit',
                  },
                }}
              >
                {menuItem.showWarning ? (
                  <Badge
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    badgeContent={<ReportProblemOutlinedIcon sx={{ fontSize: 14, color: theme.palette.warning.main }} />}
                  >
                    <Box className="menu-item-icon" sx={{ display: 'inline-flex' }}>
                      {menuItem.icon}
                    </Box>
                  </Badge>
                ) : (
                  <Box className="menu-item-icon" sx={{ display: 'inline-flex' }}>
                    {menuItem.icon}
                  </Box>
                )}
              </ListItemIcon>
              <ListItemText primary={menuItem.label} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}

export default DrawerMenuItems
